<template>
  <div class="p-configurator" id="bodytype">
    <side-banner :td_id="td_id.number" :car_id="carid.number" :p_url="p_url.p_url" />
    <confirm-reset />
    <the-title :title="title" />
    <step-menu />
    <div class="p-configurator__inner">
      <div
        class="plans"
        v-for="body in item_list"
        :key="body.code"
        @click="clickItem(body.code)"
      >
        <label class="plan">
          <input
            type="radio"
            name="plan"
            :value="body.code"
            v-model="check_code"
          />
          <div class="plan__content">
            <div class="plan__detail">
              <div class="plan__dt">
                <img :src="body.image" />
              </div>
              <div class="plan__dd">
                <p class="plan__title">{{ body.name }}</p>
                <p class="plan__price">
                  <span>¥ {{ body.price }}</span
                  >〜
                </p>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>
    <bottom-banner :td_id="td_id.number" :car_id="carid.number" :p_url="p_url.p_url" />
  </div>
</template>

<script>
import RjConfiguration from "../functions/RjConfiguration";
import ConfirmReset from "../components/ConfirmReset.vue";
import TheTitle from "../components/Title.vue";
import StepMenu from "../components/StepMenu.vue";
import SideBanner from "../components/SideBanner.vue";
import { reactive } from "vue";
import BottomBanner from "../components/BottomBanner.vue";

export default {
  components: {
    ConfirmReset,
    TheTitle,
    StepMenu,
    SideBanner,
    BottomBanner,
  },
  setup() {
    const RJ = RjConfiguration();
    //ブラウザバック時詰め直し
    RJ.getUrlFromPathName();
    const item_list = RJ.getListBodyType();
    const title = RJ.getTitle();
    const mySelect = RJ.getMySelect();
    const check_code = mySelect["value"];
    const query_key = RJ.getMenuActive()["query"];
    const item_car = RJ.getDataCar();
    let td_id = reactive({ number: item_car.testdrive_id });
    let carid = reactive({ number: item_car.catalog_id });
    let p_url = reactive({ p_url: item_car.purchase_url });

    // 選択時処理
    const clickItem = (pCode, pIndex) => {
      RJ.selectConfiguration(query_key, pCode, pIndex);
    };

    return {
      title,
      item_list,
      clickItem,
      check_code,
      td_id,
      carid,
      p_url,
    };
  },
};
</script>
<style lang="scss" scoped></style>
